import { useCallback, useContext } from 'react';
import { SharedDocument, DocumentType } from 'types/Document';
import { Image } from 'components';
import { makeStyles } from '@mui/styles';
import CreatorIcon from 'views/App/Share/ShareExplorer/FolderContentExplorer/CreatorIcon';
import { deleteModeContext } from 'views/App/Share/ShareExplorer/FolderContentExplorer/DeleteMode/DeleteModeContext';
import { imageViewerContext } from '../ImageViewer/ImageViewerContext';
import {UnknownIcon} from 'assets/icons';

const useStyles = makeStyles(() => ({
  image: {
    cursor: 'pointer',
    maxHeight: 120,
    maxWidth: 150,
  },
}), { name: 'ImagePreview' });

export type ImagePreviewProps = {
  document: SharedDocument;
};

export const ImagePreview = ({ document } : ImagePreviewProps) : JSX.Element => {
  const classes = useStyles();
  const { isDeleteMode } = useContext(deleteModeContext);
  const { handleCurrentViewedImage } = useContext(imageViewerContext);

  const handleImageClick = useCallback(() => {
    if (!isDeleteMode) {
      handleCurrentViewedImage(document);
    }
  }, [document, isDeleteMode, handleCurrentViewedImage]);

  let icon = UnknownIcon;
  if (document.type === DocumentType.PICTURE) icon = document.blob.s3URL;

  return (
    <div data-testid='image-preview'>
      <Image className={classes.image} src={icon} onClick={handleImageClick} />
      <CreatorIcon document={document} />
    </div>
  );
};

export default ImagePreview;